import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function createGuestIdentity({ baseUrl, brandId, country, clientId, clientSecret, brand, uberToken }) {
    invariant(baseUrl, 'baseUrl is a required param of createGuestIdentity()');
    invariant(country, 'country is a required param of createGuestIdentity()');
    invariant(clientId, 'clientId is a required param of createGuestIdentity()');
    invariant(brandId || brand, 'brandId is a required param of createGuestIdentity()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId || brand}_${country.toLowerCase()}/guestidentity`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST' }), uberToken, clientId, clientSecret),
        'createGuestIdentity',
    );
}
